<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="incomeFormEmploymentData.length > 0"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF INCOME FROM EMPLOYMENT</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-sm-12">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
  </div>

  <div *ngFor="let item of incomeFormEmploymentData; let idx = index" style="page-break-inside: avoid;" class="row mb-5">
    <div class="col-12 mb-3 return-view-section-title">
      {{ getEmployerName(item) }}
    </div>
    <div class="col-12 mb-3">
      <div class="return-view-text-fields">
        <div class="return-view-text-field" *ngFor="let field of getTextParticulars(item)">
          <span class="return-view-text-label">{{ getTextFieldTitle(field) }}:</span>
          <span class="return-view-text-value">{{ getTextFieldDisplayValue(item, field) }}</span>
        </div>
      </div>
    </div>

    <div class="col-12">
      <table class="table table-bordered income-employment-table">
        <thead>
          <tr class="text-center">
            <th style="width: 70%">Particulars</th>
            <th style="width: 30%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of getAmountRows(item)">
            <td>
              <div>{{ row.title }}</div>
              <div *ngIf="row.titleSecondary">{{ row.titleSecondary }}</div>
            </td>
            <td class="text-right pr-3">{{ row.amount | currencySeparatorBD }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12 mt-4" *ngIf="getNonCashBenefitRows(item) as nonCashRows">
      <ng-container *ngIf="nonCashRows.length > 0">
        <div class="text-center mb-2"><strong>Non-Cash Benefits</strong></div>
        <table class="table table-bordered income-employment-table">
          <thead>
            <tr class="text-center">
              <th style="width: 70%">Particular</th>
              <th style="width: 30%">Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of nonCashRows">
              <td>
                <div>{{ row.particular }}</div>
                <div *ngIf="row.particularSecondary">{{ row.particularSecondary }}</div>
              </td>
              <td class="text-right pr-3" *ngIf="row.isAmount">{{ row.value | currencySeparatorBD }}</td>
              <td class="text-right pr-3" *ngIf="!row.isAmount">{{ row.value }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </div>
</div>
